


$(function () {
    Highcharts.setOptions({
        //colors: ['#014f78', '#749513', '#7f1917', '#177f25', '#c8a128', '#95cbe9', '#f2583e', '#2c5700', '#de9d7f'],
        //colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],
        colors: ['#004B79', '#749513', '#CF5613', '#502209', '#3E3D40', '#97BF0D', '#FABA00', '#52B4FA', '#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],
        lang: {
            decimalPoint: ',',
            thousandsSeparator: ' '
        },
        credits:{enabled:false},
        title: {
            style: {
               color: "#333333"
            }
        },
        legend: { itemStyle: { "fontWeight": "normal" } },
        labels: { style: { fontFamily: "Verdana, Helvetica", color: "#333333" } },
        plotOptions: {
            gauge: {
                dataLabels: {
                    style: { fontFamily: "Verdana, Helvetica", color: "#333333" }
                },
                tooltip: { followTouchMove: false }
            }
        },
        
        tooltip:{followTouchMove:false},

        xAxis: {
            gridLineWidth: 0,
            lineWidth: 2,
            tickLength: 7,
            tickWidth: 2
        },
        yAxis: {
            gridLineWidth: 0,
            lineWidth: 2,
            tickLength: 7,
            tickWidth: 2,
            labels: {
                x: -12,
                y:4
            }
        }
    });

});


//Highcharts.Chart.prototype.getTable = function() {

//    // Get table cell HTML from value
//    getCellHTMLFromValue = function(tag, classes, attrs, value) {
//        var val = H.pick(value, ''),
//            className = 'text' + (classes ? ' ' + classes : '');
//        // Convert to string if number
//        if (typeof val === 'number') {
//            if (options.exporting.tableDecimalValue) {
//                val = val.toFixed(options.exporting.tableDecimalValue);
//            }
//            val = val.toString();
//            if (decimalPoint === ',') {
//                val = val.replace('.', decimalPoint);
//            }
//            className = 'number';
//        } else if (!value) {
//            className = 'empty';
//        }
//        return '<' +
//            tag +
//            (attrs ? ' ' + attrs : '') +
//            ' class="' +
//            className +
//            '">' +
//            val +
//            '</' +
//            tag +
//            '>';

//    }

//};




